import React from "react";
import clsx from "clsx";

import styles from "./uniplacesFullContainer.module.scss";

const UniplacesFullContainer = ({ children, fullContainerClassName, containerClassName }) => (
  <div className={clsx(styles.uniplacesFullContainer, fullContainerClassName)}>
    <div className={clsx(styles.uniplacesContainer, containerClassName)}>
      {children}
    </div>
  </div>
);

export default UniplacesFullContainer;
